import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet-async";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Counter from "yet-another-react-lightbox/plugins/counter";

import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/counter.css";

export default function Gallery() {
  const [open, setOpen] = useState(false);
  const [slides, setSlides] = useState([]);
  const [index, setIndex] = useState(0);

  const openGallery = (images, currentIndex) => {
    setSlides(images.map((img) => ({ src: img })));
    setIndex(currentIndex);
    setOpen(true);
  };

  const gallerySections = [
    {
      title:
        "Tree Plantation on the occassion of Gandhi  Jayanti at Gandhi Ashram",
      images: [
        "/gandhijayanti/gandhi_jayanti.png",
        "/gandhijayanti/gandhi_jayanti2.png",
        "/gandhijayanti/gandhi_jayanti3.png",
        "/gandhijayanti/gandhi_jayanti4.png",
        "/gandhijayanti/gandhi_jayanti5.png",
        "/gandhijayanti/gandhi_jayanti6.png",
        "/gandhijayanti/gandhi_jayanti7.png",
      ],
    },
    {
      title: "Baisakhi Celebration at Parliament of India",
      images: [
        "/img/gallery/baisakhi/1.png",
        "/img/gallery/baisakhi/2.png",
        "/img/gallery/baisakhi/3.png",
        "/img/gallery/baisakhi/4.png",
        "/img/gallery/baisakhi/5.png",
        "/img/gallery/baisakhi/6.png",
      ],
    },
    {
      title:
        "HRH Prince Louis called upon the Secretary-General of the Gandhi Mandela Foundation",
      images: [
        "/img/gallery/prince/1.jpg",
        "/img/gallery/prince/2.jpg",
        "/img/gallery/prince/3.jpg",
        "/img/gallery/prince/4.jpg",
        "/img/gallery/prince/5.jpg",
        "/img/gallery/prince/6.jpg",
        "/img/gallery/prince/7.jpg",
        "/img/gallery/prince/8.jpg",
      ],
    },
    {
      title: "Strengthening India–Mexico Relations through Peace Vision",
      images: [
        "/img/gallery/mexico/1.jpg",
        "/img/gallery/mexico/2.jpg",
        "/img/gallery/mexico/3.jpg",
        "/img/gallery/mexico/4.jpg",
        "/img/gallery/mexico/5.jpg",
        "/img/gallery/mexico/6.jpg",
        "/img/gallery/mexico/7.jpg",
        "/img/gallery/mexico/8.jpg",
      ],
    },
    {
      title: "Panama Delegation Visit at Rajghat",
      images: [
        "/img/gallery/panama/1.jpg",
        "/img/gallery/panama/2.jpg",
        "/img/gallery/panama/3.jpg",
        "/img/gallery/panama/4.jpg",
        "/img/gallery/panama/5.jpg",
        "/img/gallery/panama/6.jpg",
        "/img/gallery/panama/7.jpg",
        "/img/gallery/panama/8.jpg",
        "/img/gallery/panama/9.jpg",
        "/img/gallery/panama/10.jpg",
        "/img/gallery/panama/11.jpg",
        "/img/gallery/panama/12.jpg",
        "/img/gallery/panama/13.jpg",
        "/img/gallery/panama/14.jpg",
      ],
    },
    {
      title:
        "Gandhi Mandela Foundation Mexico (Celebrated Nelson Mandela Day 2025)",
      images: [
        "/img/gallery/mexico2/1.jpg",
        "/img/gallery/mexico2/2.jpg",
        "/img/gallery/mexico2/3.jpg",
        "/img/gallery/mexico2/4.jpg",
      ],
    },
    {
      title: "Honoring Peace, Unity & Global Cooperation",
      images: [
        "/img/gallery/honoring/1.jpg",
        "/img/gallery/honoring/2.jpg",
        "/img/gallery/honoring/3.jpg",
        "/img/gallery/honoring/4.jpg",
        "/img/gallery/honoring/5.jpg",
        "/img/gallery/honoring/6.jpg",
        "/img/gallery/honoring/7.jpg",
        "/img/gallery/honoring/8.jpg",
        "/img/gallery/honoring/9.jpg",
        "/img/gallery/honoring/10.jpg",
        "/img/gallery/honoring/11.jpg",
        "/img/gallery/honoring/12.jpg",
        "/img/gallery/honoring/13.jpg",
        "/img/gallery/honoring/14.jpg",
        "/img/gallery/honoring/15.jpg",
        "/img/gallery/honoring/16.jpg",
        "/img/gallery/honoring/17.jpg",
        "/img/gallery/honoring/18.jpg",
        "/img/gallery/honoring/19.jpg",
        "/img/gallery/honoring/20.jpg",
        "/img/gallery/honoring/21.jpg",
        "/img/gallery/honoring/22.jpg",
        "/img/gallery/honoring/23.jpg",
        "/img/gallery/honoring/24.jpg",
      ],
    },
    {
      title:
        "Holi Mahotsav- Organized by Lok Sabha Employee Association in collaboration with The Gandhi Mandela Foundation",
      images: [
        "/img/gallery/holimahotsav/1.jpg",
        "/img/gallery/holimahotsav/2.jpg",
        "/img/gallery/holimahotsav/3.jpg",
        "/img/gallery/holimahotsav/4.jpg",
        "/img/gallery/holimahotsav/5.jpg",
        "/img/gallery/holimahotsav/6.jpg",
        "/img/gallery/holimahotsav/7.jpg",
        "/img/gallery/holimahotsav/8.jpg",
        "/img/gallery/holimahotsav/9.jpg",
        "/img/gallery/holimahotsav/10.jpg",
        "/img/gallery/holimahotsav/11.jpg",
        "/img/gallery/holimahotsav/12.jpg",
      ],
    },
    {
      title: "Mahatma Gandhi Martyrdom Day 2025",
      images: [
        "/img/gallery/martyrdom/1.jpg",
        "/img/gallery/martyrdom/2.jpg",
        "/img/gallery/martyrdom/3.jpg",
        "/img/gallery/martyrdom/4.jpg",
        "/img/gallery/martyrdom/5.jpg",
        "/img/gallery/martyrdom/6.jpg",
        "/img/gallery/martyrdom/7.jpg",
        "/img/gallery/martyrdom/8.jpg",
        "/img/gallery/martyrdom/9.jpg",
        "/img/gallery/martyrdom/10.jpg",
        "/img/gallery/martyrdom/11.jpg",
        "/img/gallery/martyrdom/12.jpg",
        "/img/gallery/martyrdom/13.jpg",
        "/img/gallery/martyrdom/14.jpg",
        "/img/gallery/martyrdom/15.jpg",
        "/img/gallery/martyrdom/16.jpg",
        "/img/gallery/martyrdom/17.jpg",
        "/img/gallery/martyrdom/18.jpg",
        "/img/gallery/martyrdom/19.jpg",
        "/img/gallery/martyrdom/20.jpg",
        "/img/gallery/martyrdom/21.jpg",
        "/img/gallery/martyrdom/22.jpg",
        "/img/gallery/martyrdom/23.jpg",
        "/img/gallery/martyrdom/24.jpg",
        "/img/gallery/martyrdom/25.jpg",
        "/img/gallery/martyrdom/26.jpg",
        "/img/gallery/martyrdom/27.jpg",
        "/img/gallery/martyrdom/28.jpg",
      ],
    },
    {
      title:
        "The Gandhi Mandela Foundation Mexico Chapter is officially partnering with UNESCO",
      images: [
        "/img/gallery/unesco/1.jpg",
        "/img/gallery/unesco/2.jpg",
        "/img/gallery/unesco/3.jpg",
        "/img/gallery/unesco/4.jpg",
        "/img/gallery/unesco/5.jpg",
        "/img/gallery/unesco/6.jpg",
        "/img/gallery/unesco/7.jpg",
        "/img/gallery/unesco/8.jpg",
        "/img/gallery/unesco/9.jpg",
        "/img/gallery/unesco/10.jpg",
        "/img/gallery/unesco/11.jpg",
        "/img/gallery/unesco/12.jpg",
      ],
    },
    {
      title: "Gandhi Jayanti 2024",
      images: [
        "/img/gallery/gandhijayanti2024/1.jpg",
        "/img/gallery/gandhijayanti2024/2.jpg",
        "/img/gallery/gandhijayanti2024/3.jpg",
        "/img/gallery/gandhijayanti2024/4.jpg",
        "/img/gallery/gandhijayanti2024/5.jpg",
        "/img/gallery/gandhijayanti2024/6.jpg",
        "/img/gallery/gandhijayanti2024/7.jpg",
        "/img/gallery/gandhijayanti2024/8.jpg",
        "/img/gallery/gandhijayanti2024/9.jpg",
        "/img/gallery/gandhijayanti2024/10.jpg",
        "/img/gallery/gandhijayanti2024/11.jpg",
        "/img/gallery/gandhijayanti2024/12.jpg",
        "/img/gallery/gandhijayanti2024/13.jpg",
        "/img/gallery/gandhijayanti2024/14.jpg",
        "/img/gallery/gandhijayanti2024/15.jpg",
        "/img/gallery/gandhijayanti2024/16.jpg",
        "/img/gallery/gandhijayanti2024/17.jpg",
        "/img/gallery/gandhijayanti2024/18.jpg",
        "/img/gallery/gandhijayanti2024/19.jpg",
        "/img/gallery/gandhijayanti2024/20.jpg",
      ],
    },
    {
      title: "Nelson Mandela Day",
      images: [
        "/img/gallery/GMF/1.jpg",
        "/img/gallery/GMF/2.jpg",
        "/img/gallery/GMF/3.jpg",
        "/img/gallery/GMF/4.jpg",
        "/img/gallery/GMF/5.jpg",
        "/img/gallery/GMF/6.jpg",
        "/img/gallery/GMF/7.jpg",
        "/img/gallery/GMF/8.jpg",
        "/img/gallery/GMF/9.jpg",
        "/img/gallery/GMF/10.jpg",
        "/img/gallery/GMF/11.jpg",
        "/img/gallery/GMF/12.jpg",
      ],
    },
    {
      title: "GANDHI MANDELA AWARD 2019 DAY-19 NOVEMBER",
      images: [
        "/img/gallery/gmfaward2019/1.jpg",
        "/img/gallery/gmfaward2019/2.jpg",
        "/img/gallery/gmfaward2019/3.jpg",
        "/img/gallery/gmfaward2019/4.jpg",
        "/img/gallery/gmfaward2019/5.jpg",
        "/img/gallery/gmfaward2019/6.jpg",
        "/img/gallery/gmfaward2019/7.jpg",
        "/img/gallery/gmfaward2019/8.jpg",
        "/img/gallery/gmfaward2019/9.jpg",
        "/img/gallery/gmfaward2019/10.jpg",
        "/img/gallery/gmfaward2019/11.jpg",
        "/img/gallery/gmfaward2019/12.jpg",
        "/img/gallery/gmfaward2019/13.jpg",
        "/img/gallery/gmfaward2019/14.jpg",
        "/img/gallery/gmfaward2019/15.jpg",
        "/img/gallery/gmfaward2019/16.jpg",
      ],
    },

    {
      title:
        "SWEARING-IN CEREMONY FOR BOARD MEMBERS OF GANDHI MANDELA FOUNDATION",
      images: [
        "/img/gallery/swearing/1.jpg",
        "/img/gallery/swearing/2.jpg",
        "/img/gallery/swearing/3.jpg",
        "/img/gallery/swearing/4.jpg",
        "/img/gallery/swearing/5.jpg",
        "/img/gallery/swearing/6.jpg",
        "/img/gallery/swearing/7.jpg",
        "/img/gallery/swearing/8.jpg",
        "/img/gallery/swearing/9.jpg",
        "/img/gallery/swearing/10.jpg",
        "/img/gallery/swearing/11.jpg",
        "/img/gallery/swearing/12.jpg",
      ],
    },
    {
      title: "A Charitable Initiative by Gandhi Mandela Foundation",
      images: [
        "/img/gallery/charitable1/1.jpg",
        "/img/gallery/charitable1/2.jpg",
        "/img/gallery/charitable1/3.jpg",
        "/img/gallery/charitable1/4.jpg",
        "/img/gallery/charitable1/5.jpg",
        "/img/gallery/charitable1/6.jpg",
        "/img/gallery/charitable1/7.jpg",
        "/img/gallery/charitable1/8.jpg",
      ],
    },
  ];

  return (
    <>
      <Helmet>
        <title>Gallery | Gandhi Mandela Foundation</title>
        <meta
          name="description"
          content="Explore the Gandhi Mandela Foundation Gallery featuring photos of international conferences, award ceremonies, humanitarian initiatives, peace missions, educational programs, cultural events, and social welfare activities."
        />

        <meta
          name="keywords"
          content="Gandhi Mandela Foundation Gallery, GMF Gallery, Gandhi Mandela Foundation Photos, NGO Gallery India, Gandhi Mandela Foundation Events, Award Ceremony Photos, Humanitarian Activities, Peace Events, Nelson Mandela Foundation Gallery, Mahatma Gandhi Events, Social Welfare Gallery, International Conferences"
        />

        <meta name="author" content="Gandhi Mandela Foundation" />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="distribution" content="global" />
        <meta name="rating" content="general" />
        <meta name="revisit-after" content="7 days" />
        <meta name="theme-color" content="#d4a843" />

        <link
          rel="canonical"
          href="https://www.gandhimandelafoundation.com/gallery"
        />

        <link
          rel="icon"
          type="image/x-icon"
          href="%PUBLIC_URL%/favicon/favicon.ico"
        />

        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="%PUBLIC_URL%/favicon/favicon-16x16.png"
        />

        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="%PUBLIC_URL%/favicon/favicon-32x32.png"
        />

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="%PUBLIC_URL%/favicon/apple-touch-icon.png"
        />

        <link
          rel="icon"
          sizes="192x192"
          href="%PUBLIC_URL%/favicon/android-chrome-192x192.png"
        />

        <link
          rel="icon"
          sizes="512x512"
          href="%PUBLIC_URL%/favicon/android-chrome-512x512.png"
        />

        <link rel="manifest" href="%PUBLIC_URL%/favicon/site.webmanifest" />

        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Gallery | Gandhi Mandela Foundation"
        />
        <meta
          property="og:description"
          content="Discover photos from Gandhi Mandela Foundation's global events, peace initiatives, humanitarian programs, conferences, award ceremonies, and community development activities."
        />
        <meta
          property="og:url"
          content="https://www.gandhimandelafoundation.com/gallery"
        />
        <meta
          property="og:image"
          content="https://www.gandhimandelafoundation.com/images/gallery-banner.jpg"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Gallery | Gandhi Mandela Foundation"
        />
        <meta
          name="twitter:description"
          content="Browse the official gallery of Gandhi Mandela Foundation showcasing events, awards, conferences, and humanitarian initiatives."
        />
        <meta
          name="twitter:image"
          content="https://www.gandhimandelafoundation.com/images/gallery-banner.jpg"
        />
      </Helmet>

      <Header />

      <section className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span>/</span>
            <span>Gallery</span>
          </div>

          <h1>Gallery</h1>
        </div>
      </section>

      <section className="gallery-section">
        <div className="container">
          {gallerySections.map((section, sectionIndex) => (
            <div className="gallery-block" key={sectionIndex}>
              <h2 className="gallery-title">{section.title}</h2>
              {/* Sirf Yoga Day section me banner dikhega */}
              {section.title === "Nelson Mandela Day" && (
                <div
                  className="full-image-wrapper"
                  onClick={() =>
                    openGallery(
                      ["/img/gallery/GMF/1.jpg", ...section.images],
                      0,
                    )
                  }
                >
                  <img
                    src="/img/gallery/GMF/1.jpg"
                    alt="Nobel Prize winner Rigoberta Menchú Tum conferred with Gandhi Mandela Award 2020"
                    className="full-width-image"
                  />
                  <h4 align="center">
                    Nobel Prize winner Rigoberta Menchú Tum conferred with
                    Gandhi Mandela Award 2020
                  </h4>
                </div>
              )}
              <div className="gallery-grid">
                {section.images.map((image, imageIndex) => (
                  <div
                    key={imageIndex}
                    className="gallery-card"
                    onClick={() => openGallery(section.images, imageIndex)}
                  >
                    <img
                      src={image}
                      alt={`${section.title} ${imageIndex + 1}`}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={slides}
        index={index}
        plugins={[Zoom, Thumbnails, Counter]}
      />
      <Footer />
    </>
  );
}
